var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppPageContainer',{attrs:{"custom":1600,"min-height":0}},[_c('AppPageHeader',{attrs:{"design":"new","title":"Lead Flow","compact":""}}),_c('AppTabs',{attrs:{"design":"new","refined":"","weight":"medium","tabs":_vm.tabs}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }